import { EsqueceuSenha } from "./EsqueceuSenha";

export default EsqueceuSenha;